import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '@config/api.config';
import {BASE_SERVICE, BASE_SERVICE_API_VERSION} from '@constants/api.constants';
import {ApiResponse} from '@core/models/api-response.model';
import {endpoint} from '@constants/path.constants';
import {BaseEnumData} from '@core/models/enum.model';
import {States} from '@core/models/city-state.model';


@Injectable({providedIn: 'root'})
export class BaseWebservices {
  private readonly baseUrl = ApiConfig.getBaseUrl(BASE_SERVICE, BASE_SERVICE_API_VERSION);

  constructor(private http: HttpClient) {
  }

  getBaseEnum() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<BaseEnumData>>(
      this.baseUrl + endpoint.base.enum, {headers}
    );
  }

  getCityState() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<States>>(
      this.baseUrl + endpoint.base.city_state, {headers}
    );
  }

  sendOtp(payload: {
    otp_type: 'verify_user_otp' | 'verify_institute_otp';
    email?: string;
    mobile?: number;
  }) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.base.send_otp, payload, {headers}
    );
  }

  verifyOtp(payload: {
    otp_type: 'verify_user_otp' | 'verify_institute_otp';
    email?: string;
    mobile?: number;
    received_otp: number;
  }) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.base.verify_otp, payload, {headers}
    );
  }

}
